export class JobProgressStepDatabaseDataRestorationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "collectionCount",
            "baseName": "collectionCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "restoreGroupCount",
            "baseName": "restoreGroupCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "workerCount",
            "baseName": "workerCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepDatabaseDataRestorationData.attributeTypeMap;
    }
    constructor() {
    }
}
